(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion-disclosure"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__rtlAccordionInit) return;
  window.__rtlAccordionInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function panelOf(details) {
    var kids = details.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].hasAttribute('data-accordion-panel')) return kids[i];
    }
    return null;
  }

  function onMaxHeightEnd(panel, cb) {
    // Drop any pending listener first so a collapse triggered mid-expand (via
    // single-open sibling-close) cannot have the stale expand callback fire and
    // clobber the panel state.
    if (panel.__rtlMaxHeightEnd) {
      panel.removeEventListener('transitionend', panel.__rtlMaxHeightEnd);
    }
    function te(e) {
      if (e.target !== panel || e.propertyName !== 'max-height') return;
      panel.removeEventListener('transitionend', te);
      panel.__rtlMaxHeightEnd = null;
      cb();
    }
    panel.__rtlMaxHeightEnd = te;
    panel.addEventListener('transitionend', te);
  }

  // Single-open: collapse any other open accordion in the same group before
  // expanding the target, so at most one panel is open at a time. The group is
  // the nearest shared container (the target's parent), which keeps each
  // consuming section its own exclusive group rather than coupling unrelated
  // accordion clusters elsewhere on the page.
  function closeOpenSibling(details) {
    var group = details.parentElement;
    if (!group) return;
    var items = group.querySelectorAll(':scope > [data-accordion]');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item === details) continue;
      // Skip ones already collapsing; collapse open ones (including mid-expand,
      // i.e. data-animating without data-closing) so no two panels stay open.
      if (!item.open || item.hasAttribute('data-closing')) continue;
      var sibPanel = panelOf(item);
      if (sibPanel) collapse(item, sibPanel);
    }
  }

  function expand(details, panel) {
    closeOpenSibling(details);
    details.removeAttribute('data-closing');
    details.open = true;
    if (reduce.matches) return;
    details.setAttribute('data-animating', '');
    panel.style.maxHeight = '0px';
    panel.style.opacity = '0';
    void panel.offsetHeight; // force reflow so the transition runs
    panel.style.maxHeight = panel.scrollHeight + 'px';
    panel.style.opacity = '1';
    onMaxHeightEnd(panel, function () {
      panel.style.maxHeight = 'none'; // allow responsive resize once open
      details.removeAttribute('data-animating');
    });
  }

  function collapse(details, panel) {
    if (reduce.matches) {
      details.open = false;
      return;
    }
    details.setAttribute('data-animating', '');
    details.setAttribute('data-closing', ''); // flip the icon immediately
    panel.style.maxHeight = panel.scrollHeight + 'px';
    panel.style.opacity = '1';
    void panel.offsetHeight;
    panel.style.maxHeight = '0px';
    panel.style.opacity = '0';
    onMaxHeightEnd(panel, function () {
      details.open = false;
      details.removeAttribute('data-closing');
      details.removeAttribute('data-animating');
      panel.style.maxHeight = '';
      panel.style.opacity = '';
    });
  }

  document.addEventListener('click', function (e) {
    var summary = e.target.closest && e.target.closest('summary');
    if (!summary) return;
    var details = summary.closest('details[data-accordion]');
    if (!details || details.hasAttribute('data-animating')) {
      if (details) e.preventDefault();
      return;
    }
    var panel = panelOf(details);
    if (!panel) return; // no panel marked: leave native behaviour intact
    e.preventDefault(); // take over the toggle so we can animate it
    if (details.open) collapse(details, panel);
    else expand(details, panel);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["acknowledgement-of-country"] && !Shopify.designMode) return;
  try {
    (function () {
      var triggers = document.querySelectorAll('[data-acknowledgement-trigger]');
      if (!triggers.length) return;

      triggers.forEach(function (trigger) {
        if (trigger.dataset.acknowledgementBound === 'true') return;
        trigger.dataset.acknowledgementBound = 'true';

        var dialogId = trigger.getAttribute('data-acknowledgement-trigger');
        var dialog = document.getElementById(dialogId);
        if (!dialog) return;

        trigger.addEventListener('click', function () {
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            // Fallback for browsers without <dialog> support.
            dialog.setAttribute('open', '');
          }
        });

        var closeButton = dialog.querySelector('[data-acknowledgement-close]');
        if (closeButton) {
          closeButton.addEventListener('click', function () {
            if (typeof dialog.close === 'function') {
              dialog.close();
            } else {
              dialog.removeAttribute('open');
            }
          });
        }

        // Click outside the dialog body (i.e. on the backdrop) closes it.
        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) {
            if (typeof dialog.close === 'function') {
              dialog.close();
            } else {
              dialog.removeAttribute('open');
            }
          }
        });

        // Return focus to the trigger when the dialog closes.
        dialog.addEventListener('close', function () {
          trigger.focus();
        });
      });
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-quick-filters"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var TOLERANCE = 1; // sub-pixel rounding slack
    var initialized = new WeakSet();

    function reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    /* Overflow state drives three things at once: whether arrow chrome
       exists, whether each arrow is spent, and which edge gets a fade. */
    function updateState(root) {
      var list = root.querySelector('[data-quick-filters-list]');
      if (!list) return;

      var maxScroll = list.scrollWidth - list.clientWidth;
      var overflowing = maxScroll > TOLERANCE;
      var atStart = list.scrollLeft <= TOLERANCE;
      var atEnd = list.scrollLeft >= maxScroll - TOLERANCE;

      root.classList.toggle('quick-filters--overflow', overflowing);
      root.setAttribute('data-at-start', overflowing ? String(atStart) : 'true');
      root.setAttribute('data-at-end', overflowing ? String(atEnd) : 'true');

      var prev = root.querySelector('[data-quick-filters-prev]');
      var next = root.querySelector('[data-quick-filters-next]');
      if (prev) prev.disabled = !overflowing || atStart;
      if (next) next.disabled = !overflowing || atEnd;
    }

    /* Page by whole pills rather than by a fixed fraction of the rail: the
       chips are text-width, so a percentage step reliably parks one of them
       half-clipped under the fade. */
    function stepTarget(list, direction) {
      var items = list.children;
      var visibleLeft = list.scrollLeft;
      var visibleRight = visibleLeft + list.clientWidth;
      var i;
      var item;

      if (direction > 0) {
        for (i = 0; i < items.length; i++) {
          item = items[i];
          if (item.offsetLeft + item.offsetWidth > visibleRight + TOLERANCE) {
            return item.offsetLeft;
          }
        }
        return list.scrollWidth;
      }

      for (i = items.length - 1; i >= 0; i--) {
        item = items[i];
        if (item.offsetLeft < visibleLeft - TOLERANCE) {
          // Align this item's trailing edge with the rail's right edge.
          return item.offsetLeft + item.offsetWidth - list.clientWidth;
        }
      }
      return 0;
    }

    function step(root, direction) {
      var list = root.querySelector('[data-quick-filters-list]');
      if (!list) return;

      var target = stepTarget(list, direction);
      var behavior = reducedMotion() ? 'auto' : 'smooth';

      try {
        list.scrollTo({ left: target, behavior: behavior });
      } catch (err) {
        list.scrollLeft = target;
      }
    }

    /* Landing on /collections/midi-dresses with MIDI parked off-screen is a
       worse first impression than the wrapping row this replaced.
       `block: 'nearest'` keeps the page itself from jumping to the header. */
    function revealActiveChip(root) {
      var list = root.querySelector('[data-quick-filters-list]');
      if (!list) return;
      if (list.scrollWidth - list.clientWidth <= TOLERANCE) return;

      var active = list.querySelector('.quick-filters__chip--active');
      if (!active) return;

      if (active.scrollIntoView) {
        active.scrollIntoView({ inline: 'center', block: 'nearest' });
      }
    }

    function init(root) {
      if (initialized.has(root)) return;
      initialized.add(root);

      var list = root.querySelector('[data-quick-filters-list]');
      if (!list) return;

      var prev = root.querySelector('[data-quick-filters-prev]');
      var next = root.querySelector('[data-quick-filters-next]');

      if (prev) {
        prev.addEventListener('click', function () {
          step(root, -1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          step(root, 1);
        });
      }

      var scrollFrame = null;
      list.addEventListener(
        'scroll',
        function () {
          if (scrollFrame) return;
          scrollFrame = window.requestAnimationFrame(function () {
            scrollFrame = null;
            updateState(root);
          });
        },
        { passive: true }
      );

      // Chip widths move with the webfont swap and with container resizes,
      // either of which can create or resolve an overflow after first paint.
      if (window.ResizeObserver) {
        var observer = new ResizeObserver(function () {
          updateState(root);
        });
        observer.observe(list);
      } else {
        var resizeFrame = null;
        window.addEventListener('resize', function () {
          if (resizeFrame) return;
          resizeFrame = window.requestAnimationFrame(function () {
            resizeFrame = null;
            updateState(root);
          });
        });
      }

      updateState(root);
      revealActiveChip(root);
      // scrollIntoView above moves the rail; re-measure the arrow/fade state.
      updateState(root);
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-quick-filters]');
      Array.prototype.forEach.call(roots, init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    // Theme editor section re-render.
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["currency-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    function getModal() {
      return document.querySelector('[data-currency-modal]');
    }

    function open() {
      var modal = getModal();
      if (!modal) return;
      modal.removeAttribute('hidden');
      modal.removeAttribute('inert');
      // Force reflow before adding `is-open` so the transition fires.
      void modal.offsetHeight;
      modal.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      // Focus the currently-checked radio so its option-button receives
      // the focus-visible outline alongside the selected-state border.
      // Falling back to the first radio when none is pre-checked.
      var focusTarget =
        modal.querySelector('[data-currency-modal-radio]:checked') ||
        modal.querySelector('[data-currency-modal-radio]');
      if (focusTarget) {
        setTimeout(function () { focusTarget.focus(); }, 0);
      }
      document.addEventListener('keydown', onKeyDown);
    }

    function close() {
      var modal = getModal();
      if (!modal) return;
      modal.classList.remove('is-open');
      // Drop the auto-surface styling so a subsequent manual open is clean.
      modal.classList.remove('is-auto');
      modal.setAttribute('hidden', '');
      modal.setAttribute('inert', '');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKeyDown);
    }

    function onKeyDown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
      }
    }

    /* The cross-store redirect + load of the destination storefront
       takes time over the network. Overlay a body-level loading
       spinner so the user sees instant feedback. The overlay is
       destroyed by the page navigation. */
    function showLoadingOverlay() {
      if (document.querySelector('.locale-loading-overlay')) return;
      var overlay = document.createElement('div');
      overlay.className = 'locale-loading-overlay';
      overlay.setAttribute('role', 'status');
      overlay.setAttribute('aria-live', 'polite');
      overlay.setAttribute('aria-label', 'Switching store');
      var spinner = document.createElement('div');
      spinner.className = 'locale-loading-overlay__spinner';
      overlay.appendChild(spinner);
      document.body.appendChild(overlay);
    }

    /* Selecting a region redirects the browser to that region's
       separate storefront (different domain), retaining the current
       path + query so the user lands on the equivalent page. This is
       symmetric: the same logic deployed on either store redirects to
       the other. A same-origin guard makes selecting the current
       store a harmless no-op (just close the modal).

       Pending visual: pin the inverted (black/white) state on the
       clicked option via a `.is-submitting` class and lock further
       interaction via `aria-busy` on the radiogroup wrapper, so the
       selected region stays highlighted regardless of cursor position
       across the redirect window. */
    var isRedirecting = false;

    function onRegionChange(event) {
      var radio = event.target;
      if (!radio || !radio.checked) return;
      if (isRedirecting) return;

      var base = (radio.getAttribute('data-store-url') || '').replace(/\/+$/, '');
      if (!base) return;

      // No-op if it's already the current store (same origin) -- just
      // close the modal. 
      try {
        if (new URL(base).origin === window.location.origin) {
          close();
          return;
        }
      } catch (e) {}

      isRedirecting = true;
      var wrap = radio.closest('[data-currency-modal-form-wrap]');
      if (wrap) wrap.setAttribute('aria-busy', 'true');
      var option = radio.closest('.currency-modal__option');
      if (option) option.classList.add('is-submitting');

      var target = base + window.location.pathname + window.location.search;

      // Close the modal first for instant acknowledgement, then surface
      // the page-level loading overlay, then redirect.
      close();
      showLoadingOverlay();
      window.location.assign(target);
    }

    /* ---- Geo-mismatch auto-surface -------------------------------------
       When a visitor lands on the store for the wrong region (e.g. an
       AU/NZ shopper on the US / Rest-of-world store) we open this modal
       once, unprompted, so they can switch. Per Shopify's guidance we
       PROMPT rather than auto-redirect (geo-IP is imperfect, VPNs, etc.).

       Suppressed for 24 hours after it fires -- we store the timestamp in
       localStorage rather than a bare flag so the suppression expires and a
       returning visitor is prompted again the next day, instead of never
       again (#324). localStorage (not sessionStorage) keeps the suppression
       shared across tabs. */
    var PROMPT_SEEN_KEY = 'rtl:region-prompt-seen';
    var PROMPT_TTL_MS = 24 * 60 * 60 * 1000;

    function promptAlreadySeen() {
      try {
        /* Legacy values from before the TTL landed were the bare string '1',
           which parses to NaN here and so reads as expired -- those visitors
           get prompted once more, then pick up a real timestamp. */
        var seenAt = parseInt(localStorage.getItem(PROMPT_SEEN_KEY), 10);
        if (isNaN(seenAt)) return false;
        var age = Date.now() - seenAt;
        /* A negative age means the clock moved backwards (or was wrong when
           we stamped it) -- treat as expired rather than trusting it. */
        if (age < 0) return false;
        return age < PROMPT_TTL_MS;
      } catch (e) { return false; }
    }

    function markPromptSeen() {
      try { localStorage.setItem(PROMPT_SEEN_KEY, String(Date.now())); } catch (e) {}
    }

    /* Map a country code to one of the two storefront regions:
       AU/NZ -> the AU/NZ store; everything else -> US / Rest of world. */
    function regionForCountry(code) {
      if (!code) return null;
      var c = String(code).toUpperCase();
      if (c === 'AU' || c === 'NZ') return 'au';
      return 'us';
    }

    /* Timezone fallback for when the geo endpoint yields nothing (common on
       a single-market store). Only needs to separate AU/NZ from the rest --
       we never *guess* 'us' from a timezone (too coarse), we just leave it
       undecided so no false prompt fires. */
    function regionFromTimezone() {
      try {
        var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
        if (tz.indexOf('Australia/') === 0 || tz === 'Pacific/Auckland') return 'au';
        return null;
      } catch (e) { return null; }
    }

    /* Resolve the visitor's region. Prefers Shopify's native browsing-context
       suggestion (geo-IP + browser signals), falls back to timezone. */
    function detectRegion() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url = root + 'browsing_context_suggestions.json?country[enabled]=true';
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var country = data && data.detected_values && data.detected_values.country;
          var handle = country && country.handle;
          return regionForCountry(handle) || regionFromTimezone();
        })
        .catch(function () { return regionFromTimezone(); });
    }

    function maybeAutoSurface(modal) {
      if (promptAlreadySeen()) return;
      var current = modal.getAttribute('data-current-region');
      if (!current) return;
      detectRegion().then(function (detected) {
        if (!detected || detected === current) return;
        markPromptSeen();
        modal.classList.add('is-auto');
        open();
      });
    }

    function init() {
      var modal = getModal();
      if (!modal) return;
      var overlay = modal.querySelector('[data-currency-modal-overlay]');
      var closeBtn = modal.querySelector('[data-currency-modal-close]');
      var continueBtn = modal.querySelector('[data-currency-modal-continue]');
      var radios = modal.querySelectorAll('[data-currency-modal-radio]');

      if (overlay) overlay.addEventListener('click', close);
      if (closeBtn) closeBtn.addEventListener('click', close);
      if (continueBtn) continueBtn.addEventListener('click', close);

      for (var i = 0; i < radios.length; i++) {
        radios[i].addEventListener('change', onRegionChange);
      }

      /* Each label's visible button is a sibling of the radio (the radio
         is positioned `left: -100%` off-screen so the structural diff
         matches live's tree). That kills Chrome's native label->input
         click-forward because the click target sits outside the radio's
         bounding rect. Wire the option-button to toggle its sibling radio
         explicitly. The radio's `change` event then triggers
         onRegionChange (the cross-store redirect). */
      var labels = modal.querySelectorAll('.currency-modal__option');
      for (var j = 0; j < labels.length; j++) {
        (function (label) {
          var button = label.querySelector('.currency-modal__option-button');
          var radio = label.querySelector('[data-currency-modal-radio]');
          if (!button || !radio) return;
          button.addEventListener('click', function (e) {
            if (radio.checked) return;
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          });
        })(labels[j]);
      }

      document.addEventListener('currency-modal:open', open);

      maybeAutoSurface(modal);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["locale-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('currency-modal:open', { bubbles: true }));
      });
    }
    document.querySelectorAll('[data-locale-selector-trigger]').forEach(init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-nav-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var FOCUSABLE_SELECTOR =
      'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function MobileNavController(root) {
      this.root = root;
      this.panels = Array.prototype.slice.call(
        root.querySelectorAll('[data-mobile-nav-panel]')
      );
      this.panelStack = ['root'];
      this.isOpen = false;
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onPageHide = this.onPageHide.bind(this);
      this.bindEvents();
    }

    MobileNavController.prototype.bindEvents = function () {
      var self = this;

      // Toggles live anywhere on the document (e.g. inside header.liquid).
      document.addEventListener('click', function (event) {
        var toggle = event.target.closest('[data-mobile-nav-toggle]');
        if (toggle && toggle.getAttribute('aria-controls') === self.root.id) {
          event.preventDefault();
          self.open(toggle);
        }
      });

      // The drawer is only rendered below the header's hamburger swap point
      // (72rem). If the viewport crosses into desktop while the drawer is
      // open, the sheet vanishes with CSS but `mobile-nav-open` would stay on
      // <html>, leaving the page scroll-locked with no way to close (#329).
      // Close on the crossing so state follows the layout.
      if (window.matchMedia) {
        var desktopQuery = window.matchMedia('(min-width: 72rem)');
        var onBreakpointChange = function (event) {
          if (event.matches) self.close();
        };
        if (desktopQuery.addEventListener) {
          desktopQuery.addEventListener('change', onBreakpointChange);
        } else if (desktopQuery.addListener) {
          // Safari < 14 / older WebKit.
          desktopQuery.addListener(onBreakpointChange);
        }
      }

      // Close + open-panel + back live inside the drawer.
      this.root.addEventListener('click', function (event) {
        var closeTarget = event.target.closest('[data-mobile-nav-close]');
        if (closeTarget) {
          event.preventDefault();
          self.close();
          return;
        }

        var openTarget = event.target.closest('[data-mobile-nav-open]');
        if (openTarget) {
          event.preventDefault();
          self.openPanel(openTarget.getAttribute('data-mobile-nav-open'));
          return;
        }

        var backTarget = event.target.closest('[data-mobile-nav-back]');
        if (backTarget) {
          event.preventDefault();
          self.back();
          return;
        }
      });
    };

    MobileNavController.prototype.findPanel = function (panelId) {
      for (var i = 0; i < this.panels.length; i++) {
        if (this.panels[i].getAttribute('data-mobile-nav-panel') === panelId) {
          return this.panels[i];
        }
      }
      return null;
    };

    MobileNavController.prototype.open = function (trigger) {
      if (this.isOpen) return;
      this.isOpen = true;
      this.trigger = trigger || null;

      this.root.removeAttribute('hidden');
      // Force reflow so the slide-in animates rather than snapping.
      void this.root.offsetWidth;

      this.root.classList.add('mobile-nav--open');
      this.root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('mobile-nav-open');
      if (trigger && trigger.setAttribute) {
        trigger.setAttribute('aria-expanded', 'true');
      }

      document.addEventListener('keydown', this.onKeyDown);
      window.addEventListener('pagehide', this.onPageHide);

      // Focus the first focusable after the slide-in. `preventScroll: true`
      // stops the browser from auto-scrolling the `.mobile-nav__panels`
      // container to bring the focused element into view -- without it,
      // focusing a button inside a still-animating sub-panel drifts the
      // panels container's scrollLeft, leaving the sub-panel rendered
      // at viewport x=-210 instead of x=0 once the transition completes.
      var self = this;
      window.requestAnimationFrame(function () {
        var active = self.activePanel();
        var firstFocusable = active
          ? active.querySelector(FOCUSABLE_SELECTOR)
          : null;
        if (firstFocusable) firstFocusable.focus({ preventScroll: true });
      });
    };

    MobileNavController.prototype.close = function () {
      if (!this.isOpen) return;
      this.isOpen = false;

      this.root.classList.remove('mobile-nav--open');
      this.root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('mobile-nav-open');
      if (this.trigger && this.trigger.setAttribute) {
        this.trigger.setAttribute('aria-expanded', 'false');
      }

      document.removeEventListener('keydown', this.onKeyDown);
      window.removeEventListener('pagehide', this.onPageHide);

      this.resetPanels();

      // Hide after the slide-out transition so it remains animated.
      var self = this;
      window.setTimeout(function () {
        if (!self.isOpen) self.root.setAttribute('hidden', '');
      }, 220);

      if (this.trigger && this.trigger.focus) {
        try {
          this.trigger.focus();
        } catch (err) {
          /* trigger may have been removed; swallow */
        }
      }
    };

    MobileNavController.prototype.openPanel = function (panelId) {
      var nextPanel = this.findPanel(panelId);
      if (!nextPanel) return;

      var currentId = this.panelStack[this.panelStack.length - 1];
      var currentPanel = this.findPanel(currentId);

      if (currentPanel) {
        currentPanel.classList.remove('mobile-nav__panel--active');
        currentPanel.classList.add('mobile-nav__panel--shifted');
        currentPanel.setAttribute('aria-hidden', 'true');
      }

      nextPanel.classList.remove('mobile-nav__panel--shifted');
      nextPanel.classList.add('mobile-nav__panel--active');
      nextPanel.removeAttribute('aria-hidden');

      this.panelStack.push(panelId);
      this.syncSubOpenClass();

      var firstFocusable = nextPanel.querySelector(FOCUSABLE_SELECTOR);
      if (firstFocusable) firstFocusable.focus({ preventScroll: true });
    };

    MobileNavController.prototype.back = function () {
      if (this.panelStack.length <= 1) return;

      var currentId = this.panelStack.pop();
      var previousId = this.panelStack[this.panelStack.length - 1];
      var currentPanel = this.findPanel(currentId);
      var previousPanel = this.findPanel(previousId);

      if (currentPanel) {
        currentPanel.classList.remove('mobile-nav__panel--active');
        currentPanel.setAttribute('aria-hidden', 'true');
      }

      if (previousPanel) {
        previousPanel.classList.remove('mobile-nav__panel--shifted');
        previousPanel.classList.add('mobile-nav__panel--active');
        previousPanel.removeAttribute('aria-hidden');

        var firstFocusable = previousPanel.querySelector(FOCUSABLE_SELECTOR);
        if (firstFocusable) firstFocusable.focus({ preventScroll: true });
      }
      this.syncSubOpenClass();
    };

    MobileNavController.prototype.resetPanels = function () {
      for (var i = 0; i < this.panels.length; i++) {
        var panel = this.panels[i];
        var id = panel.getAttribute('data-mobile-nav-panel');
        panel.classList.remove('mobile-nav__panel--shifted');
        if (id === 'root') {
          panel.classList.add('mobile-nav__panel--active');
          panel.removeAttribute('aria-hidden');
        } else {
          panel.classList.remove('mobile-nav__panel--active');
          panel.setAttribute('aria-hidden', 'true');
        }
      }
      this.panelStack = ['root'];
      this.syncSubOpenClass();
    };

    // Toggles the `.mobile-nav--sub-open` modifier on the root element
    // whenever the active panel is anything other than the root panel.
    // The locale-selector slot listens for this class to slide / fade off-
    // screen (matches the headless `.localeSelector.visible` rule which
    // ties the locale slot's visibility to "no secondary nav is open").
    MobileNavController.prototype.syncSubOpenClass = function () {
      var active = this.panelStack[this.panelStack.length - 1];
      if (active && active !== 'root') {
        this.root.classList.add('mobile-nav--sub-open');
      } else {
        this.root.classList.remove('mobile-nav--sub-open');
      }
    };

    MobileNavController.prototype.activePanel = function () {
      var id = this.panelStack[this.panelStack.length - 1];
      return this.findPanel(id);
    };

    MobileNavController.prototype.onKeyDown = function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }

      if (event.key !== 'Tab') return;

      var panel = this.activePanel();
      if (!panel) return;

      var focusables = Array.prototype.slice
        .call(panel.querySelectorAll(FOCUSABLE_SELECTOR))
        .filter(function (el) {
          return el.offsetParent !== null || el === document.activeElement;
        });
      if (focusables.length === 0) return;

      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    MobileNavController.prototype.onPageHide = function () {
      // Full-page navigation in classic themes -- reset state so the next
      // pageview starts clean (matches the headless pathname-effect close).
      this.close();
    };

    function init() {
      var roots = document.querySelectorAll('[data-mobile-nav]');
      for (var i = 0; i < roots.length; i++) {
        if (!roots[i].__mobileNavController) {
          roots[i].__mobileNavController = new MobileNavController(roots[i]);
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function initVideoObserver(card) {
      var video = card.querySelector('[data-product-card-video]');
      if (!video) return;
      // Honour prefers-reduced-motion: skip autoplay entirely
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              // #297 R2: play() rejects when the browser cannot decode the
              // source (several custom_video values are .mov) or when autoplay
              // is blocked. Swallow the rejection so the poster image stays as
              // the graceful fallback with no uncaught-promise console noise.
              var playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(function () {});
              }
            } else {
              video.pause();
            }
          });
        },
        { rootMargin: '200px', threshold: 0 }
      );
      observer.observe(video);
    }

    function initQuickAdd(card) {
      var trigger = card.querySelector('[data-action="open-quick-add"]');
      var panel = card.querySelector('.product-card__quick-add-panel');
      var titleLink = card.querySelector('.product-card__title-link');
      if (!panel) return;

      function openPanel() {
        card.classList.add('is-quick-add-open');
        var firstRadio = panel.querySelector('input[type="radio"]:not([disabled])');
        if (firstRadio) {
          requestAnimationFrame(function () { firstRadio.focus(); });
        }
      }

      function closePanel() {
        card.classList.remove('is-quick-add-open');
        if (titleLink) titleLink.focus();
      }

      if (trigger) {
        trigger.addEventListener('click', openPanel);
      }

      // ArrowUp on title link opens the quick-add panel
      if (titleLink) {
        titleLink.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowUp') {
            e.preventDefault();
            openPanel();
          }
        });
      }

      // Escape or ArrowDown inside the panel closes it and returns focus
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'ArrowDown') {
          e.preventDefault();
          closePanel();
        }
      });

      initQuickAddToCart(card, panel, closePanel);
    }

    function initQuickAddToCart(card, panel, closePanel) {
      var fieldset = panel.querySelector('.product-card__sizes');
      if (!fieldset) return;
      var liveRegion = panel.querySelector('[data-quick-add-live]');

      fieldset.addEventListener('change', function (e) {
        var radio = e.target;
        if (!radio || radio.type !== 'radio') return;
        var variantId = radio.dataset.variantId;
        if (!variantId) return;

        // Disable only currently-enabled radios while request is in flight
        var allRadios = Array.prototype.slice.call(
          fieldset.querySelectorAll('input[type="radio"]')
        );
        var enabledRadios = allRadios.filter(function (r) { return !r.disabled; });
        enabledRadios.forEach(function (r) { r.disabled = true; });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
          .then(function (addRes) {
            if (!addRes.ok) throw new Error('cart/add.js returned ' + addRes.status);
            return addRes.json();
          })
          .then(function (added) {
            // Klaviyo "Added to Cart" (#58). `added` is the /cart/add.js
            // response ({ items: [...] } for this JSON POST).
            if (window.RTLKlaviyo) window.RTLKlaviyo.trackAddedToCart(added);
            // Algolia "Added to cart after search" (#341). No-ops unless the
            // product was opened from search results. `1` is the quantity
            // posted above: the response's `quantity` is the line's new total.
            if (window.RTLAlgoliaInsights) window.RTLAlgoliaInsights.trackAddedToCart(added, 1);
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          })
          .then(function (cartRes) { return cartRes.json(); })
          .then(function (cart) {
            card.dispatchEvent(
              new CustomEvent('cart:updated', { detail: cart, bubbles: true })
            );
            if (liveRegion) {
              liveRegion.textContent = 'Added to cart';
              setTimeout(function () { liveRegion.textContent = ''; }, 3000);
            }
            closePanel();
          })
          .catch(function (err) {
            console.warn('[product-card] quick-add failed:', err);
            if (liveRegion) {
              liveRegion.textContent = 'Could not add to cart. Please try again.';
              setTimeout(function () { liveRegion.textContent = ''; }, 5000);
            }
          })
          .finally(function () {
            // Re-enable the radios that were available before the request
            enabledRadios.forEach(function (r) { r.disabled = false; });
          });
      });
    }

    // Idempotency guard (#297): cards injected after first paint by the PDP
    // recommendation / recently-viewed rails (Section Rendering API +
    // localStorage) are re-scanned by the MutationObserver below. Stamp each
    // card on first init so a re-scan never re-binds the quick-add change /
    // keydown / click listeners -- double-binding would fire cart/add.js twice.
    function initCards() {
      var cards = document.querySelectorAll('.product-card');
      Array.prototype.forEach.call(cards, function (card) {
        if (card.dataset.productCardInit === 'true') return;
        card.dataset.productCardInit = 'true';
        initVideoObserver(card);
        initQuickAdd(card);
      });
    }

    // Re-init cards added to the DOM after load (#297). The PDP "You may also
    // like", "Customers also viewed", and "Recently viewed" rails render
    // skeletons at first paint and inject their real .product-card markup
    // asynchronously, so those cards miss the initial initCards() pass and
    // their video IntersectionObserver never attaches. A single debounced
    // MutationObserver catches every injection path (innerHTML replacement and
    // appendChild) plus the theme-editor shopify:section:load re-render, with
    // no coordination needed in the injecting sections. The per-card guard
    // above keeps the recurring re-scan cheap and side-effect-free.
    var reinitQueued = false;
    function scheduleReinit() {
      if (reinitQueued) return;
      reinitQueued = true;
      requestAnimationFrame(function () {
        reinitQueued = false;
        initCards();
      });
    }

    function observeInjectedCards() {
      if (!('MutationObserver' in window) || !document.body) return;
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            scheduleReinit();
            return;
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    function boot() {
      initCards();
      observeInjectedCards();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var SCROLL_TOLERANCE = 1; // sub-pixel rounding tolerance
    var initialized = new WeakSet();

    function reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function getSlideStep(viewport) {
      var firstSlide = viewport.querySelector('.product-carousel__slide');
      if (!firstSlide) return viewport.clientWidth;
      var rect = firstSlide.getBoundingClientRect();
      var trackStyle = window.getComputedStyle(viewport.querySelector('.product-carousel__track'));
      var gap = parseFloat(trackStyle.columnGap || trackStyle.gap || '0') || 0;
      return Math.max(1, Math.round(rect.width + gap));
    }

    function updateArrowState(carousel) {
      var viewport = carousel.querySelector('[data-carousel-viewport]');
      var prev = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      var arrowsWrapper = carousel.querySelector('[data-carousel-arrows]');
      if (!viewport) return;

      var atStart = viewport.scrollLeft <= SCROLL_TOLERANCE;
      var atEnd =
        viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - SCROLL_TOLERANCE;

      // Single-slide / no-overflow case: both ends true at once.
      var noOverflow = viewport.scrollWidth - viewport.clientWidth <= SCROLL_TOLERANCE;

      if (prev) prev.hidden = atStart || noOverflow;
      if (next) next.hidden = atEnd || noOverflow;

      if (arrowsWrapper) {
        // Hide the arrows container only when both prev and next are unavailable.
        arrowsWrapper.hidden = noOverflow;
      }
    }

    function announceCurrentSlide(carousel) {
      var viewport = carousel.querySelector('[data-carousel-viewport]');
      var live = carousel.querySelector('[data-carousel-live]');
      if (!viewport || !live) return;

      var slides = carousel.querySelectorAll('.product-carousel__slide');
      var total = slides.length;
      if (!total) return;

      var step = getSlideStep(viewport);
      var index = Math.min(total, Math.max(1, Math.round(viewport.scrollLeft / step) + 1));

      var template = live.getAttribute('data-template') || 'Slide {current} of {total}';
      live.textContent = template
        .replace('{current}', index)
        .replace('{total}', total);
    }

    function scrollByStep(carousel, direction) {
      var viewport = carousel.querySelector('[data-carousel-viewport]');
      if (!viewport) return;
      var step = getSlideStep(viewport);
      var behavior = reducedMotion() ? 'auto' : 'smooth';

      try {
        viewport.scrollBy({ left: direction * step, behavior: behavior });
      } catch (err) {
        viewport.scrollLeft = viewport.scrollLeft + direction * step;
      }
    }

    function initCarousel(carousel) {
      if (initialized.has(carousel)) return;
      initialized.add(carousel);

      var viewport = carousel.querySelector('[data-carousel-viewport]');
      if (!viewport) return;

      var prev = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');

      if (prev) {
        prev.addEventListener('click', function () {
          scrollByStep(carousel, -1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          scrollByStep(carousel, 1);
        });
      }

      viewport.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          scrollByStep(carousel, -1);
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          scrollByStep(carousel, 1);
        }
      });

      var scrollFrame = null;
      viewport.addEventListener('scroll', function () {
        if (scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(function () {
          scrollFrame = null;
          updateArrowState(carousel);
          announceCurrentSlide(carousel);
        });
      });

      var resizeFrame = null;
      window.addEventListener('resize', function () {
        if (resizeFrame) return;
        resizeFrame = window.requestAnimationFrame(function () {
          resizeFrame = null;
          updateArrowState(carousel);
        });
      });

      // Initial paint -- fire after layout so scrollWidth/clientWidth are accurate.
      window.requestAnimationFrame(function () {
        updateArrowState(carousel);
        announceCurrentSlide(carousel);
      });
    }

    function initAll() {
      var carousels = document.querySelectorAll('.product-carousel');
      Array.prototype.forEach.call(carousels, initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Re-init when sections are reloaded in the theme editor.
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function initGallery(section) {
    var viewport = section.querySelector('[data-gallery-viewport]');
    var container = section.querySelector('[data-gallery-container]');
    var ariaEl = section.querySelector('[data-gallery-aria]');
    var totalSlides = parseInt(section.dataset.totalSlides, 10) || 0;

    if (!viewport || !container || totalSlides === 0) return;

    var MQ = window.matchMedia('(max-width: 1023px)');

    // Progress bar is injected only on mobile (not in HTML template).
    // Keeps desktop DOM clean -- no extra-in-build element at desktop widths.
    var progressEl = null;
    var progressBar = null;
    function ensureProgressBar() {
      if (progressEl) return;
      progressEl = document.createElement('div');
      progressEl.className = 'product-gallery__progress';
      progressEl.setAttribute('data-gallery-progress', '');
      progressBar = document.createElement('div');
      progressBar.className = 'product-gallery__progress-bar';
      progressBar.setAttribute('data-gallery-progress-bar', '');
      progressEl.appendChild(progressBar);
      viewport.appendChild(progressEl);
    }

    var currentIndex = 0;
    var startX = 0;
    var startY = 0;
    var diffX = 0;
    var isDragging = false;
    var isHorizontal = null;
    var slideWidth = 0;
    var DRAG_THRESHOLD = 5;

    function getSlideWidth() {
      return viewport.offsetWidth;
    }

    function goTo(index) {
      if (index < 0) index = 0;
      if (index >= totalSlides) index = totalSlides - 1;
      currentIndex = index;

      var offset = -(currentIndex * slideWidth);
      container.style.transform = 'translateX(' + offset + 'px)';
      container.style.transition = 'transform 0.3s ease';

      updateProgress();
      updateAria();
    }

    function updateProgress(dragOffset) {
      if (!progressBar) return;
      // Mirror the headless useProgress hook (Embla scrollProgress): the bar
      // has left: -100% and width: 100%, translated right by progress% of its
      // own width. At slide 0 of N, progress = 100/N (1/N of bar shows).
      //
      // When `dragOffset` is provided, factor the in-progress drag distance
      // into the progress reading so the bar tracks the user's finger
      // continuously rather than jumping at slide-commit time. Matches the
      // live Embla `scrollProgress` behaviour.
      var slidesProgress = totalSlides > 0
        ? (currentIndex + 1) / totalSlides
        : 0;

      if (dragOffset && slideWidth > 0) {
        // dragOffset is the diff in px; positive = dragging right (towards
        // previous slide), negative = dragging left (towards next slide).
        // A full-slide drag should add/subtract 1/N to the progress.
        var dragFraction = -dragOffset / slideWidth / totalSlides;
        slidesProgress = slidesProgress + dragFraction;
        // Clamp to [1/N, 1] to mirror Embla's progress clamp.
        var minProgress = totalSlides > 0 ? 1 / totalSlides : 0;
        if (slidesProgress < minProgress) slidesProgress = minProgress;
        if (slidesProgress > 1) slidesProgress = 1;
      }

      progressBar.style.transform = 'translateX(' + (slidesProgress * 100) + '%)';
    }

    function updateAria() {
      if (!ariaEl) return;
      ariaEl.textContent = ariaEl.textContent.replace(/\d+/, currentIndex + 1);
    }

    function onPointerDown(e) {
      if (!MQ.matches) return;
      ensureProgressBar();
      slideWidth = getSlideWidth();
      startX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
      startY = e.type === 'touchstart' ? e.touches[0].clientY : e.clientY;
      diffX = 0;
      isDragging = true;
      isHorizontal = null;
      container.style.transition = 'none';
      if (progressBar) progressBar.classList.add('product-gallery__progress-bar--dragging');
    }

    function onPointerMove(e) {
      if (!isDragging) return;
      var x = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
      var y = e.type === 'touchmove' ? e.touches[0].clientY : e.clientY;
      diffX = x - startX;
      var diffY = y - startY;

      if (isHorizontal === null) {
        if (Math.abs(diffX) > DRAG_THRESHOLD || Math.abs(diffY) > DRAG_THRESHOLD) {
          isHorizontal = Math.abs(diffX) >= Math.abs(diffY);
        }
      }

      if (isHorizontal) {
        if (e.cancelable) e.preventDefault();
        var offset = -(currentIndex * slideWidth) + diffX;
        container.style.transform = 'translateX(' + offset + 'px)';
        // Match Embla's `scrollProgress` continuous update so the bar
        // tracks the finger live -- otherwise it appears static during the
        // drag, which read as "progress bar missing" in QA R2.
        updateProgress(diffX);
      }
    }

    function onPointerUp() {
      if (!isDragging) return;
      isDragging = false;
      if (progressBar) progressBar.classList.remove('product-gallery__progress-bar--dragging');
      if (isHorizontal && Math.abs(diffX) > slideWidth * 0.2) {
        if (diffX < 0) {
          goTo(currentIndex + 1);
        } else {
          goTo(currentIndex - 1);
        }
      } else {
        goTo(currentIndex);
      }
      isHorizontal = null;
    }

    viewport.addEventListener('touchstart', onPointerDown, { passive: true });
    viewport.addEventListener('touchmove', onPointerMove, { passive: false });
    viewport.addEventListener('touchend', onPointerUp);
    viewport.addEventListener('mousedown', onPointerDown);
    viewport.addEventListener('mousemove', onPointerMove);
    viewport.addEventListener('mouseup', onPointerUp);
    viewport.addEventListener('mouseleave', onPointerUp);

    viewport.setAttribute('tabindex', '0');
    viewport.addEventListener('keydown', function (e) {
      if (!MQ.matches) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(currentIndex - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentIndex + 1); }
    });

    slideWidth = getSlideWidth();
    if (MQ.matches) {
      ensureProgressBar();
    }
    goTo(0);

    window.addEventListener('resize', function () {
      slideWidth = getSlideWidth();
      if (MQ.matches) {
        ensureProgressBar();
      }
      goTo(currentIndex);
    });

    initLightbox(section);
  }

  function initLightbox(section) {
    var dialog = section.querySelector('[data-gallery-lightbox]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var stage = dialog.querySelector('[data-lightbox-stage]');
    var figures = Array.prototype.slice.call(dialog.querySelectorAll('[data-lightbox-figure]'));
    var ariaEl = dialog.querySelector('[data-lightbox-aria]');
    var closeBtn = dialog.querySelector('[data-lightbox-close]');
    var prevBtn = dialog.querySelector('[data-lightbox-prev]');
    var nextBtn = dialog.querySelector('[data-lightbox-next]');
    var triggers = Array.prototype.slice.call(section.querySelectorAll('[data-gallery-zoom-trigger]'));
    var total = figures.length;
    if (total === 0) return;

    var current = 0;
    var lastTrigger = null;
    var desktopMQ = window.matchMedia('(min-width: 1024px)');

    function activeFigure() {
      return figures[current];
    }

    function activeImage() {
      var fig = activeFigure();
      return fig ? fig.querySelector('.product-lightbox__image') : null;
    }

    function resetZoom(img) {
      if (!img) return;
      img.style.setProperty('--zoom-scale', '1');
      img.style.setProperty('--zoom-origin', 'center center');
      img.removeAttribute('data-zoomed');
    }

    var ariaTemplate = (ariaEl && ariaEl.getAttribute('data-aria-template')) || 'Image __C__ of __T__';

    function announce() {
      if (!ariaEl) return;
      ariaEl.textContent = ariaTemplate
        .replace('__C__', current + 1)
        .replace('__T__', total);
    }

    function show(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      figures.forEach(function (fig, i) {
        var isActive = i === index;
        fig.hidden = !isActive;
        if (!isActive) resetZoom(fig.querySelector('.product-lightbox__image'));
      });
      current = index;
      resetZoom(activeImage());
      announce();
    }

    function open(index, trigger) {
      lastTrigger = trigger || document.activeElement;
      show(index);
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      if (dialog.open) dialog.close();
    }

    dialog.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      resetZoom(activeImage());
      if (lastTrigger && typeof lastTrigger.focus === 'function') {
        lastTrigger.focus();
      }
    });

    triggers.forEach(function (trigger) {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.addEventListener('click', function () {
        var idx = parseInt(trigger.getAttribute('data-zoom-index'), 10) || 0;
        open(idx, trigger);
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var idx = parseInt(trigger.getAttribute('data-zoom-index'), 10) || 0;
          open(idx, trigger);
        }
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });

    // Backdrop click (clicking the dialog element itself, outside the inner content) closes.
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) close();
    });

    // Desktop click-to-toggle 2x zoom centred on cursor.
    stage.addEventListener('click', function (e) {
      if (!desktopMQ.matches) return;
      var img = e.target.closest('.product-lightbox__image');
      if (!img) return;
      var zoomed = img.getAttribute('data-zoomed') === 'true';
      if (zoomed) {
        resetZoom(img);
      } else {
        var rect = img.getBoundingClientRect();
        var ox = ((e.clientX - rect.left) / rect.width) * 100;
        var oy = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.setProperty('--zoom-origin', ox + '% ' + oy + '%');
        img.style.setProperty('--zoom-scale', '2');
        img.setAttribute('data-zoomed', 'true');
      }
    });

    // Keyboard: arrows cycle (Escape is handled natively by <dialog>).
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); }
    });

    // Swipe-to-dismiss + swipe-to-cycle on touch.
    var tStartX = 0;
    var tStartY = 0;
    var tActive = false;
    dialog.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tActive = false; return; }
      tActive = true;
      tStartX = e.touches[0].clientX;
      tStartY = e.touches[0].clientY;
    }, { passive: true });
    dialog.addEventListener('touchend', function (e) {
      if (!tActive) return;
      tActive = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - tStartX;
      var dy = t.clientY - tStartY;
      // Ignore gestures while the image is pinch-zoomed/scrolled.
      var fig = activeFigure();
      if (fig && (fig.scrollTop > 4 || fig.scrollLeft > 4)) return;
      if (Math.abs(dy) > 80 && Math.abs(dy) > Math.abs(dx)) {
        close();
      } else if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) {
        show(dx < 0 ? current + 1 : current - 1);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.product-gallery').forEach(initGallery);
    });
  } else {
    document.querySelectorAll('.product-gallery').forEach(initGallery);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.product-gallery');
    if (section) initGallery(section);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-info"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  /* ---------------------------------------------------------------- */
  /* Accordion: single-open, animate via scrollHeight                  */
  /* ---------------------------------------------------------------- */
  function initAccordion(sectionEl) {
    var accordion = sectionEl.querySelector('[data-accordion]');
    if (!accordion) return;

    var items = Array.from(accordion.querySelectorAll('[data-accordion-item]'));

    /* Multi-open mode ships every panel expanded on load and toggles each one
       independently, so a panel only closes when the user clicks it. Single-open
       mode (the flag absent) keeps the original behaviour: one panel at a time. */
    var multiOpen = accordion.hasAttribute('data-accordion-multi');

    function openItem(item) {
      var trigger = item.querySelector('[data-accordion-trigger]');
      var panel = item.querySelector('[data-accordion-panel]');
      if (!trigger || !panel) return;

      item.classList.add('product-info-accordion__item--active');
      trigger.setAttribute('aria-expanded', 'true');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }

    function closeItem(item) {
      var trigger = item.querySelector('[data-accordion-trigger]');
      var panel = item.querySelector('[data-accordion-panel]');
      if (!trigger || !panel) return;

      item.classList.remove('product-info-accordion__item--active');
      trigger.setAttribute('aria-expanded', 'false');
      panel.style.maxHeight = '0';
    }

    /* Set initial max-height for any item open on load */
    function syncOpenPanels() {
      items.forEach(function (item) {
        var panel = item.querySelector('[data-accordion-panel]');
        if (!panel) return;
        if (item.classList.contains('product-info-accordion__item--active')) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        } else {
          panel.style.maxHeight = '0';
        }
      });
    }

    syncOpenPanels();

    /* Re-measure once web fonts swap in and whenever the column reflows -- a
       panel opened on load is pinned to a pixel height, so a taller relayout
       would otherwise clip the copy. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncOpenPanels);
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncOpenPanels, 150);
    });

    accordion.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-accordion-trigger]');
      if (!trigger) return;

      var clickedItem = trigger.closest('[data-accordion-item]');
      if (!clickedItem) return;

      var isCurrentlyActive = clickedItem.classList.contains('product-info-accordion__item--active');

      if (multiOpen) {
        /* Independent toggle -- siblings keep whatever state they are in */
        if (isCurrentlyActive) {
          closeItem(clickedItem);
        } else {
          openItem(clickedItem);
        }
        return;
      }

      /* Close all items */
      items.forEach(function (item) {
        closeItem(item);
      });

      /* If it was closed, open it */
      if (!isCurrentlyActive) {
        openItem(clickedItem);
      }
    });
  }

  /* ---------------------------------------------------------------- */
  /* Recommendations SRA fetch                                          */
  /* ---------------------------------------------------------------- */
  /**
   * Algolia Recommend path for the sidebar grid. Claims the TOP 3 handles from
   * the shared ranked list in `algolia-recommendations.js` -- this runs before
   * the full-width rail and the "Customers also viewed" tab, so it gets rank
   * 1-3 and the others continue from rank 4.
   *
   * Replaces the old positional dedup, where this grid took the first 3 after
   * a gender gate while `recently-viewed` skipped 3 of the RAW list -- the two
   * overlapped whenever a top-3 related product was the opposite gender.
   */
  function recommendationsFromAlgolia(container) {
    if (container.dataset.algoliaEnabled !== 'true') {
      return Promise.reject(new Error('algolia disabled'));
    }
    var objectId = container.dataset.objectId;
    if (!window.RTLRecsReady || !objectId) {
      return Promise.reject(new Error('algolia unavailable'));
    }

    var recs;
    var claimedHandles = [];
    return window.RTLRecsReady
      .then(function (api) {
        recs = api;
        return recs.handles({
          objectID: objectId,
          model: container.dataset.model,
          gender: container.dataset.pdpGender,
          exclude: container.dataset.excludeHandles
        });
      })
      .then(function (list) {
        claimedHandles = recs.claim(container.dataset.claimKey, list, 3);
        if (!claimedHandles.length) throw new Error('no algolia handles');
        // Compact card section -- badges on, no swatch row, 150px image slot,
        // matching this grid's Liquid fallback path above. The full-width rail
        // uses the default `algolia-recommendation-card` instead.
        return recs.cards(claimedHandles, 'algolia-recommendation-card-compact');
      })
      .then(function (cards) {
        if (!cards.length) throw new Error('no algolia cards');

        var grid = container.querySelector('.product-info-recommendations__grid');
        var heading = container.querySelector('.product-info-recommendations__heading');
        if (!grid) throw new Error('grid missing');

        while (grid.firstChild) grid.removeChild(grid.firstChild);
        cards.forEach(function (card) {
          var item = document.createElement('li');
          item.className = 'product-info-recommendations__item';
          item.appendChild(card);
          grid.appendChild(item);
        });

        grid.classList.remove('product-info-recommendations__grid--loading');
        grid.removeAttribute('aria-busy');
        if (heading) {
          heading.classList.remove('product-info-recommendations__heading--skeleton');
          heading.removeAttribute('aria-hidden');
        }
      })
      .catch(function (err) {
        // Hand any claimed-but-unrendered handles back before dropping to the
        // Shopify fallback, so the rail and the tab can still use them.
        if (recs && claimedHandles.length) {
          recs.release(container.dataset.claimKey, claimedHandles);
        }
        throw err;
      });
  }

  function initRecommendations(sectionEl) {
    var container = sectionEl.querySelector('[data-product-recommendations]');
    if (!container) return;

    // Algolia first, Shopify `related` as the fallback.
    recommendationsFromAlgolia(container).catch(function () {
      recommendationsFromShopify(container);
    });
  }

  function recommendationsFromShopify(container) {
    var productId = container.dataset.productId;
    var sectionId = container.dataset.sectionId;
    var limit = container.dataset.limit || '3';
    var intent = container.dataset.intent || 'related';
    var fetchUrl = container.dataset.fetchUrl;

    if (!fetchUrl || !productId || !sectionId) return;

    var url =
      fetchUrl +
      '?section_id=' + encodeURIComponent(sectionId) +
      '&product_id=' + encodeURIComponent(productId) +
      '&limit=' + encodeURIComponent(limit) +
      '&intent=' + encodeURIComponent(intent);

    fetch(url)
      .then(function (response) {
        if (!response.ok) return;
        return response.text();
      })
      .then(function (html) {
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fetched = doc.querySelector('[data-product-recommendations]');
        if (fetched) {
          container.innerHTML = fetched.innerHTML;
        }
      })
      .catch(function () {
        /* Recommendations are non-critical -- fail silently */
      });
  }

  /* ---------------------------------------------------------------- */
  /* Rating button scroll to reviews                                   */
  /* ---------------------------------------------------------------- */
  function initRatingScroll(sectionEl) {
    var ratingBtn = sectionEl.querySelector('[data-product-reviews-anchor]');
    if (!ratingBtn) return;

    ratingBtn.addEventListener('click', function () {
      var reviewsSection = document.getElementById('rtl-product-reviews');
      if (reviewsSection) {
        reviewsSection.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  /* ---------------------------------------------------------------- */
  /* Init                                                               */
  /* ---------------------------------------------------------------- */
  document.querySelectorAll('[data-section-type="product-info"]').forEach(function (sectionEl) {
    initAccordion(sectionEl);
    initRecommendations(sectionEl);
    initRatingScroll(sectionEl);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-overview"] && !Shopify.designMode) return;
  try {
    // Client-side zero-review guard. The server-side guard handles products whose
  // okendo.summaryData metafield reports zero reviews, but when that metafield
  // is absent (Okendo hydrates the count client-side) we collapse the rating
  // button once Okendo finishes injecting markup and the rating element is
  // still empty - so no reserved empty gap remains for zero-review products.
  (function () {
    var button = document.querySelector('[data-rating-button]');
    if (!button) return;

    var rating = button.querySelector('[data-oke-star-rating]');
    if (!rating) return;

    function hasRatingContent() {
      if (rating.children.length > 0) return true;
      return rating.textContent.trim().length > 0;
    }

    function evaluate() {
      if (hasRatingContent()) {
        button.removeAttribute('hidden');
        return true;
      }
      return false;
    }

    // If Okendo has already hydrated, nothing more to do.
    if (evaluate()) return;

    // Hide until we know there is at least one review, then watch for Okendo
    // injecting the stars markup.
    button.setAttribute('hidden', '');

    var observer = new MutationObserver(function () {
      if (evaluate()) observer.disconnect();
    });
    observer.observe(rating, { childList: true, subtree: true, characterData: true });

    // Stop watching after a reasonable window - if no stars arrived the product
    // has no reviews and the button stays collapsed.
    window.setTimeout(function () {
      observer.disconnect();
      evaluate();
    }, 8000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 768px)';

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function initStickyAtc(bar) {
    if (bar.hasAttribute('data-sticky-mounted')) return;
    bar.setAttribute('data-sticky-mounted', '');

    var form = document.querySelector('[data-product-form]');
    var inPageSubmit = form
      ? form.querySelector('[data-product-form-submit]')
      : null;
    var oosRoot = document.querySelector('[data-product-oos-form]');
    var button = bar.querySelector('[data-sticky-atc-button]');
    var label = bar.querySelector('[data-sticky-atc-label]');
    var sizeSelect = bar.querySelector('[data-sticky-size]');
    var variantIdInput = form
      ? form.querySelector('[data-product-form-variant-id]')
      : null;

    if (!form || !inPageSubmit || !button) return;

    /* Portal to <body> so the bar escapes any PDP stacking context. */
    if (bar.parentElement !== document.body) {
      document.body.appendChild(bar);
    }

    var addLabel = bar.getAttribute('data-label-add') || '';
    var notifyLabel = bar.getAttribute('data-label-notify') || '';
    if (label) {
      addLabel = addLabel || label.textContent.trim();
    }

    var atcInView = true;
    var footerInView = false;

    function isSoldOut() {
      /* In-page submit is hidden by product-form.js when the variant is OOS. */
      return inPageSubmit.hasAttribute('hidden');
    }

    function applyVisibility() {
      if (!isMobile()) {
        bar.classList.remove('product-sticky-atc--visible');
        /* Root-level hook consumed by snippets/gorgias-launcher-position.liquid
           to lift the Gorgias launcher above the bar. Cleared above the
           breakpoint so the launcher rests normally on desktop. */
        document.documentElement.classList.remove('sticky-atc-visible');
        return;
      }
      var shouldShow = !atcInView && !footerInView;
      bar.classList.toggle('product-sticky-atc--visible', shouldShow);
      document.documentElement.classList.toggle('sticky-atc-visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    function syncState() {
      var soldOut = isSoldOut();
      if (label) {
        label.textContent = soldOut ? notifyLabel : addLabel;
      }
      /* Mirror the in-page form's current variant id back to the sticky
         select so size changes in the chip selector keep the dropdown in
         sync. The variant id input is the canonical source -- product-form.js
         writes it on every size change. */
      if (sizeSelect && variantIdInput && variantIdInput.value) {
        if (sizeSelect.value !== variantIdInput.value) {
          sizeSelect.value = variantIdInput.value;
        }
      }
    }

    /* Sticky select -> main form: set the matching radio chip checked and
       dispatch a `change` on the form so onSizeChange in product-form.js
       syncs the hidden variant id, price and availability. Falls back to
       writing the variant id directly when there is no matching radio
       (defensive -- the chip selector always renders one per variant). */
    if (sizeSelect) {
      sizeSelect.addEventListener('change', function () {
        /* #340: release focus once a size is picked. iOS Safari otherwise
           spends the next tap dismissing the native picker, so the first
           ADD TO CART tap only flashed the button without adding. */
        sizeSelect.blur();
        var variantId = sizeSelect.value;
        if (!variantId) return;
        var radio = form.querySelector(
          'input[name="options[Size]"][value="' + variantId + '"]'
        );
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (variantIdInput) {
          variantIdInput.value = variantId;
          form.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    button.addEventListener('click', function () {
      if (isSoldOut()) {
        /* Route to the back-in-stock waitlist, mirroring in-page behaviour. */
        if (oosRoot) {
          oosRoot.removeAttribute('hidden');
          oosRoot.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var emailInput = oosRoot.querySelector('[data-product-oos-email]');
          if (emailInput) {
            window.setTimeout(function () {
              emailInput.focus();
            }, 400);
          }
        }
        return;
      }
      /* Delegate to the real in-page form submit - single source of truth
         for /cart/add.js + the cart:updated event. */
      button.setAttribute('aria-busy', 'true');
      inPageSubmit.click();
      window.setTimeout(function () {
        button.removeAttribute('aria-busy');
      }, 800);
    });

    /* Keep CTA + price in sync when the size selection changes. */
    form.addEventListener('change', function () {
      window.setTimeout(syncState, 0);
    });
    document.addEventListener('cart:updated', syncState);

    /* Reveal/hide on the in-page ATC leaving/entering the viewport. */
    if ('IntersectionObserver' in window) {
      var atcObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            atcInView = entry.isIntersecting;
          });
          applyVisibility();
        },
        { threshold: 0 }
      );
      atcObserver.observe(inPageSubmit);

      var footer = document.querySelector('footer, .footer, [data-section-type="footer"]');
      if (footer) {
        var footerObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              footerInView = entry.isIntersecting;
            });
            applyVisibility();
          },
          { threshold: 0 }
        );
        footerObserver.observe(footer);
      }
    }

    window.matchMedia(MOBILE_QUERY).addEventListener('change', applyVisibility);

    syncState();
    bar.removeAttribute('hidden');
    applyVisibility();
  }

  function init() {
    var bar = document.querySelector('[data-product-sticky-atc]');
    if (bar) initStickyAtc(bar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["products-grid-view-toggle"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var LS_KEY = 'rtl:collection-view';
    var VALID_VIEWS = ['4', '2'];

    function initViewToggle() {
      var grid = document.querySelector('[data-collection-grid]');
      var buttons = document.querySelectorAll('[data-view-toggle-btn]');

      if (!grid || !buttons.length) return;

      function applyView(val, animate) {
        buttons.forEach(function (btn) {
          btn.setAttribute('aria-pressed', String(btn.dataset.viewToggleBtn === val));
        });

        if (animate) {
          grid.style.opacity = '0';
          setTimeout(function () {
            grid.setAttribute('data-view', val);
            grid.style.opacity = '';
          }, 150);
        } else {
          grid.setAttribute('data-view', val);
        }
      }

      var stored = localStorage.getItem(LS_KEY);
      if (stored && VALID_VIEWS.indexOf(stored) !== -1) {
        applyView(stored, false);
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = btn.dataset.viewToggleBtn;
          localStorage.setItem(LS_KEY, val);
          applyView(val, true);
        });
      });
    }

    document.addEventListener('DOMContentLoaded', initViewToggle);
    document.addEventListener('shopify:section:load', initViewToggle);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide-panel"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_KEY = 'size-unit';
    var FOCUSABLE_SELECTOR =
      'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function SizeGuideController(root) {
      this.root = root;
      this.sheet = root.querySelector('[data-size-guide-sheet]');
      this.heading = root.querySelector('[data-size-guide-heading]');
      this.isOpen = false;
      this.trigger = null;
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onPageHide = this.onPageHide.bind(this);
      this.bindEvents();
      this.applyUnit(this.readStoredUnit());
    }

    SizeGuideController.prototype.readStoredUnit = function () {
      try {
        var v = window.localStorage.getItem(STORAGE_KEY);
        if (v === 'cm' || v === 'in') return v;
      } catch (err) {
        /* localStorage unavailable - fall through */
      }
      return 'cm';
    };

    SizeGuideController.prototype.writeStoredUnit = function (unit) {
      try {
        window.localStorage.setItem(STORAGE_KEY, unit);
      } catch (err) {
        /* swallow */
      }
    };

    SizeGuideController.prototype.bindEvents = function () {
      var self = this;

      // Open triggers live anywhere on the document.
      document.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-size-guide-open]');
        if (trigger && trigger.getAttribute('aria-controls') === self.root.id) {
          event.preventDefault();
          self.open(trigger);
        }
      });

      // Close + unit-toggle live inside the panel.
      this.root.addEventListener('click', function (event) {
        var closeTarget = event.target.closest('[data-size-guide-close]');
        if (closeTarget) {
          event.preventDefault();
          self.close();
          return;
        }

        var unitTarget = event.target.closest('[data-size-guide-unit]');
        if (unitTarget) {
          event.preventDefault();
          var unit = unitTarget.getAttribute('data-size-guide-unit');
          if (unit === 'cm' || unit === 'in') {
            self.applyUnit(unit);
            self.writeStoredUnit(unit);
          }
        }
      });
    };

    SizeGuideController.prototype.applyUnit = function (unit) {
      this.root.setAttribute('data-active-unit', unit);

      var buttons = this.root.querySelectorAll('[data-size-guide-unit]');
      for (var i = 0; i < buttons.length; i++) {
        var btn = buttons[i];
        var isActive = btn.getAttribute('data-size-guide-unit') === unit;
        if (isActive) {
          btn.classList.add('size-guide__toggle-button--active');
          btn.setAttribute('aria-pressed', 'true');
        } else {
          btn.classList.remove('size-guide__toggle-button--active');
          btn.setAttribute('aria-pressed', 'false');
        }
      }

      var attr = 'data-' + unit;
      var cells = this.root.querySelectorAll('[data-cm][data-in]');
      for (var j = 0; j < cells.length; j++) {
        var cell = cells[j];
        var value = cell.getAttribute(attr);
        if (value !== null) cell.textContent = value;
      }
    };

    SizeGuideController.prototype.open = function (trigger) {
      if (this.isOpen) return;
      this.isOpen = true;
      this.trigger = trigger || null;

      this.root.removeAttribute('hidden');
      void this.root.offsetWidth; // reflow → animate
      this.root.classList.add('size-guide--open');
      this.root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('size-guide-open');

      if (this.trigger && this.trigger.setAttribute) {
        this.trigger.setAttribute('aria-expanded', 'true');
      }

      // Re-apply stored unit each open so a tab in another window can't
      // leave us out of sync.
      this.applyUnit(this.readStoredUnit());

      document.addEventListener('keydown', this.onKeyDown);
      window.addEventListener('pagehide', this.onPageHide);

      var self = this;
      window.requestAnimationFrame(function () {
        var closeBtn = self.root.querySelector('.size-guide__close');
        if (closeBtn) closeBtn.focus();
      });
    };

    SizeGuideController.prototype.close = function () {
      if (!this.isOpen) return;
      this.isOpen = false;

      this.root.classList.remove('size-guide--open');
      this.root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('size-guide-open');

      if (this.trigger && this.trigger.setAttribute) {
        this.trigger.setAttribute('aria-expanded', 'false');
      }

      document.removeEventListener('keydown', this.onKeyDown);
      window.removeEventListener('pagehide', this.onPageHide);

      var self = this;
      window.setTimeout(function () {
        if (!self.isOpen) self.root.setAttribute('hidden', '');
      }, 220);

      if (this.trigger && this.trigger.focus) {
        try {
          this.trigger.focus();
        } catch (err) {
          /* trigger may have been removed; swallow */
        }
      }
    };

    SizeGuideController.prototype.onKeyDown = function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }

      if (event.key !== 'Tab') return;

      var focusables = Array.prototype.slice
        .call(this.sheet.querySelectorAll(FOCUSABLE_SELECTOR))
        .filter(function (el) {
          return el.offsetParent !== null || el === document.activeElement;
        });
      if (focusables.length === 0) return;

      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    SizeGuideController.prototype.onPageHide = function () {
      this.close();
    };

    function init() {
      var roots = document.querySelectorAll('[data-size-guide]');
      for (var i = 0; i < roots.length; i++) {
        if (!roots[i].__sizeGuideController) {
          roots[i].__sizeGuideController = new SizeGuideController(roots[i]);
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tolstoy-stories"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    if (window.__rtlTolstoyLoaded) return;
    window.__rtlTolstoyLoaded = true;

    // 1. Expose the app key on the global so the widget loader
    //    authenticates against the merchant's Tolstoy account.
    //    Matches `components/Scripts/index.tsx` in the headless
    //    repo: `tolstoyAppKey = "34780528-..."`.
    var keyScript = document.createElement('script');
    keyScript.id = 'tolstoy-app-key';
    keyScript.text = 'tolstoyAppKey="34780528-8027-47e9-9df5-f9e7ac33ac5e"';
    document.head.appendChild(keyScript);

    // 2. Module + nomodule widget loaders. Mirrors the headless
    //    `<Script strategy="lazyOnload">` triplet.
    function appendScript(attrs) {
      var s = document.createElement('script');
      Object.keys(attrs).forEach(function (k) {
        if (k === 'text') {
          s.text = attrs[k];
        } else if (attrs[k] === true) {
          s.setAttribute(k, '');
        } else {
          s.setAttribute(k, attrs[k]);
        }
      });
      document.head.appendChild(s);
    }

    appendScript({
      id: 'tolstoy-widget-module',
      type: 'module',
      async: true,
      src: 'https://widget.gotolstoy.com/we/widget.js'
    });

    appendScript({
      id: 'tolstoy-widget-nomodule',
      nomodule: true,
      async: true,
      src: 'https://widget.gotolstoy.com/widget/widget.js'
    });

    appendScript({
      id: 'tolstoy-widget-v2',
      type: 'module',
      src: 'https://play.gotolstoy.com/widget-v2/widget.js'
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["view-more"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function initViewMore(container) {
      var btn = container.querySelector('[data-view-more-button]');
      if (!btn) return;

      var grid = document.querySelector('[data-view-more-grid]');
      if (!grid) return;

      var statusEl = container.querySelector('[data-view-more-status]');
      var progressEl = container.querySelector('[data-view-more-progress]');
      var labelView = btn.getAttribute('data-label-view') || btn.textContent.trim();

      btn.addEventListener('click', function (e) {
        var nextUrl = btn.getAttribute('data-next-url');
        if (!nextUrl) return;
        // Trigger is now an <a href="..."> for noscript progressive
        // enhancement; preventDefault stops the browser from full-
        // navigating to the next page so the fetch-and-append below
        // can run.
        if (e && e.preventDefault) e.preventDefault();

        btn.classList.add('is-loading');
        btn.textContent = btn.getAttribute('data-label-loading') || 'Loading…';

        fetch(nextUrl)
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-view-more-grid]');
            var newContainer = doc.querySelector('[data-view-more-container]');

            if (newGrid) {
              var existingIds = new Set();
              grid.querySelectorAll('[data-product-id]').forEach(function (el) {
                existingIds.add(el.getAttribute('data-product-id'));
              });
              grid.querySelectorAll('[data-article-id]').forEach(function (el) {
                existingIds.add(el.getAttribute('data-article-id'));
              });

              Array.from(newGrid.children).forEach(function (child) {
                var id = child.getAttribute('data-product-id') || child.getAttribute('data-article-id');
                if (id && existingIds.has(id)) return;
                grid.appendChild(child.cloneNode(true));
              });
            }

            if (newContainer) {
              var newBtn = newContainer.querySelector('[data-view-more-button]');
              var newStatus = newContainer.querySelector('[data-view-more-status]');
              var newProgress = newContainer.querySelector('[data-view-more-progress]');

              // #298: count the cards actually in the DOM so "viewed" always
              // matches what the customer sees, regardless of how many items
              // the per-card filter (#204 OOS-hide) dropped on each page. The
              // fetched page's server number assumes every prior page rendered
              // a full page of cards, which drifts once any page hides one.
              var viewed = grid.querySelectorAll('[data-product-id], [data-article-id]').length;
              var total = viewed;
              if (newProgress) {
                total = parseInt(newProgress.getAttribute('data-total') || '0', 10) || viewed;
              }

              // #298 R2: when the fetched page carries no "View More" button we
              // have loaded the final page -- collapse the total onto the live
              // DOM count so the end-state reads "N of N" (e.g. "27 of 27")
              // instead of the catalogued "27 of 38" the customer can never
              // reach. Matches the server-side has_next==false collapse above.
              if (!newBtn) {
                total = viewed;
              }

              if (statusEl) {
                var template = statusEl.getAttribute('data-status-template');
                if (template) {
                  // #298 R2: rebuild the localised status from the template with
                  // string-coerced numbers so the load-more copy renders cleanly
                  // (no stray placeholder / entity / concatenation artefacts).
                  statusEl.textContent = template
                    .replace('__SHOWN__', String(viewed))
                    .replace('__TOTAL__', String(total));
                } else if (newStatus) {
                  statusEl.textContent = newStatus.textContent.trim();
                }
              }

              if (progressEl) {
                progressEl.setAttribute('data-visible', viewed);
                progressEl.setAttribute('data-total', total);
                if (total > 0) {
                  progressEl.style.width = (viewed / total * 100) + '%';
                }
              }

              if (newBtn) {
                btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
                btn.classList.remove('is-loading');
                btn.textContent = labelView;
              } else {
                // QA R2 3i / M3h: keep the status counter + progress bar
                // visible on the final page. Previously we removed the
                // entire container which made "You've viewed N of M
                // products" disappear once the last page was loaded.
                btn.remove();
              }
            } else {
              // Same as above -- if the next page lacks a container we
              // still want the original status copy to remain visible
              // alongside a full progress bar.
              btn.remove();
            }

            history.pushState(null, '', nextUrl);
          })
          .catch(function () {
            btn.classList.remove('is-loading');
            btn.textContent = labelView;
          });
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      var container = document.querySelector('[data-view-more-container]');
      if (container) initViewMore(container);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
